export default __webpack_public_path__ + "static/media/PlayToggleIcon.e4b4f310.svg";